// 日志管理
import http from "@/jslibs/axios/http";

// 日志分页列表
export const page = ({ page, size, ...data }) => http.post(`/cms/log/page?page=${page}&size=${size}`, data);

// 模块枚举列表
export const moduleList = (data) => http.get("/cms/log/moduleList", data);

// 操作类型枚举列表
export const typeList = (data) => http.get("/cms/log/typeList", data);

// 日志分页列表
export const excel = (data) => http.post("/cms/log/excel", data, { responseType: 'blob'});
